export default __webpack_public_path__ + "static/media/company-young-guys-welcoming-each-other-car.d897061a.jpg";